export var colors = {
    baseRed: '#ec4c47',
    baseOrange: '#d9822b',
    dark2: '#425a70',
};
